export default __webpack_public_path__ + "8e8858daadd06e74fafa314fab06e4e3.png";